import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { api } from '../app/api';
import { authenticatedUserReducers } from './authenticatedUser/reducers';
import { cardReducers } from './card/reducers';
import { chargePointReducers } from './chargePoint/reducers';
import { loadBalancingGroupReducers } from './loadBalancingGroup/reducers';
import { locationReducers } from './location/reducers';
import { organisationReducers } from './organisation/reducers';
import { organisationUserReducers } from './organisationUser/reducers';
import { rootSaga } from './root';
import { userReducers } from './user/reducers';

export const setUpStore = () => {
  const sagaMiddleware = createSagaMiddleware();

  const store = configureStore({
    devTools: process.env.NODE_ENV === 'development',
    reducer: {
      [api.reducerPath]: api.reducer,
      authenticatedUser: authenticatedUserReducers,
      card: cardReducers,
      chargePoint: chargePointReducers,
      loadBalancingGroup: loadBalancingGroupReducers,
      location: locationReducers,
      organisation: organisationReducers,
      organisationUser: organisationUserReducers,
      user: userReducers,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ serializableCheck: false, immutableCheck: false }).concat(sagaMiddleware, api.middleware),
  });

  sagaMiddleware.run(rootSaga);

  return store;
};
